import  {useEffect, useState} from "react";
import {formatDistance, isValid} from "date-fns";
import {enUS} from 'date-fns/locale';

export function getRelativeTime(timestamp, suffix='ago') {
    if(isValid(timestamp)) {
        return `${formatDistance(new Date(timestamp), new Date(), {locale: enUS})} ${suffix}`;
    }
    return ``;
}

export const useTimeLeft = (startTime) => {
    const [leftTime, setLeftTime] = useState('');
    useEffect(() => {
        setLeftTime(getRelativeTime(startTime, ''));
        const remainingSecond = setInterval(() =>
            setLeftTime(getRelativeTime(startTime, '')), 1000);
        return () => clearInterval(remainingSecond);
    }, [startTime]);
    return leftTime;
}


// WEBPACK FOOTER //
// ./src/components/driverPackageSummary/TimeLeft.js